import Glide from '@glidejs/glide';

export default () => {

    let windowWidth = window.innerWidth;

    // Load first adformat product on init
    let product_id = $('.admarket-style:first-of-type').data('id');
    $('.admarket-style:first-of-type').addClass('slick-active');
    $('.adformat-content-showcase').addClass('swoop-effect');
    display_adformat_ajax_content(product_id); // init

    /**
     * AJAX function load adformat
     * */
    function display_adformat_ajax_content(product_id) {

        jQuery.ajax({
            url: horizon.ajaxUrl,
            type: 'post',
            data: {
                action: 'adformat_showcase_action',
                product_post_id: product_id,
                current_page_id: horizon.current_page_id
            },
            success: function(data) {
                $('.adformat-content-showcase').removeClass('swoop-effect');
                jQuery('.adformat-showcase-block__holder').html(data); // Show new AJAX data
            }
        });
    }
    //Show related format on click
    $('.admarket-style').on('click', function() {
        let product_id = parseInt($(this).data('id'));

        display_adformat_ajax_content(product_id);

        $('.admarket-style').removeClass('slick-active');
        $('.adformat-content-showcase').addClass('swoop-effect');
        $(this).toggleClass('slick-active');
    });

    // Add the afterChange event listener
    $('.adformat-showcase-slider').on('afterChange', function(event, slick, currentSlide) {
        // Run the AJAX function every time a slide changes
        let productId = $('.admarket-style.slick-active').data('id');
        display_adformat_ajax_content(productId);
        $('.adformat-content-showcase').addClass('swoop-effect');
    });


    /** Load all posts in all categories on init */
    let amountToShowOnInit = 12;
    load_posts_by_cat('All', amountToShowOnInit);
    $('.ajax-readmore').attr('data-amount', amountToShowOnInit * 2); // First time we click we want to show start amount * 2

    /**
     * AJAX Load posts by cat
     **/
    function load_posts_by_cat(category, amount) {
        jQuery.ajax({
            url: horizon.ajaxUrl,
            type: 'post',
            data: {
                action: 'filter_cat_posts',
                cat_name: category,
                amount: amount
            },
            success: function(data) {

                $('.ajax-posts .news-object, .ajax-readmore').removeClass('swoop-effect');
                
                jQuery('.ajax-posts').html(data); // Show new AJAX data
                $('.ajax-readmore').attr('data-amount', amount); // Override
                $('.ajax-readmore').prop('disabled', false); // Override


                // Read more button click
                $('.ajax-readmore').on('click', function() {

                    let amount = parseInt($(this).attr('data-amount'));
                    let category = $('.cat-post-filter.slick-active').data('category-name');

                    console.log(amount);

                    amount = amount + 3;
                    load_posts_by_cat(category, amount);

                    $(this).attr('data-amount', amount);
                    $(this).addClass('swoop-effect z-1');
                    $('.ajax-readmore').prop('disabled', true); // Override
                });

            }
        });
    }

    // Filter to category
    $('.cat-post-filter').on('click', function() {
        let category = $(this).data('category-name');
        $('.ajax-posts .news-object').addClass('swoop-effect');
        load_posts_by_cat(category, amountToShowOnInit); // Reset the amount counter when we filter
    });

    /**
     *
     * Glidejs case-slider block
     */

    const caseSlider = document.querySelector('.case-slider');
    if(caseSlider !== null) {
        var caseGlide = new Glide('.case-slider', {
            type: 'carousel',
            perView: 3,
            focusAt: 'center',
            gap: 40,
            breakpoints: {
                771: { perView: 1}
            }
        });
        caseGlide.mount();
    }

    /**
     *
     * Glidejs testemonials-slider block
     */

    const testemonialsSlider = document.querySelector('.glide.testemonials');
    if(testemonialsSlider !== null) {
        var testemonialsGlide = new Glide('.glide.testemonials', {
            type: 'slider',
            autoplay: 7500,
            perView: 2,
            breakpoints: {
                564: { perView: 1 }
            }
        });
        testemonialsGlide.mount();
    }

    if ($('.adformat-showcase-slider').length) {
    
        $('.adformat-showcase-slider').slick({
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        centerMode: false,
        focusOnSelect: true,
        variableWidth: true,
        swipe: false,
        prevArrow: $('.custom-arrow.slick-prev'), // Use the custom HTML for prev arrow
        nextArrow: $('.custom-arrow.slick-next')  // Use the custom HTML for next arrow
        });

    }

    if ($('.hero-elevated-content').length) {

        $('.hero-elevated-content').slick({
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            centerMode: false,
            focusOnSelect: true,
            prevArrow: $('.small-nav-arrow.slick-prev'), // Use the custom HTML for prev arrow
            nextArrow: $('.small-nav-arrow.slick-next'),  // Use the custom HTML for next arrow
            responsive: [
            {
                breakpoint: 1024, // Screen width up to 1024px
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                }
            },
            {
                breakpoint: 600, // Screen width up to 600px
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can add more breakpoints and settings here
        ]
        });

    }

    /**
     *
     * Glidejs logotyper block
     */

    const logotypSlider = document.querySelector('.glide.logotyp');
    if(logotypSlider !== null) {
        var logotypGlide = new Glide('.glide.logotyp', {
            type: 'carousel',
            autoplay: 3500,
            perView: 7,
            breakpoints: {
                978: { perView: 7 },
                771: { perView: 6 }
            }
        });
        logotypGlide.mount();
    }

    /** Varumärke */
    if($('.only-show-first-row')[0]) {
        $('#toggleAllProducts').on('click', function() {

            let siteLang = document.getElementsByTagName('html')[0].getAttribute('lang');
            if(siteLang == 'sv-SE') {
                var btnStrOpen = 'Visa fler format';
                var btnStrClose = 'Visa färre format';
            } else {
                var btnStrOpen = 'Show more formats';
                var btnStrClose = 'Show less formats';
            }

            $('.only-show-first-row').toggleClass('open');
            if ($('.only-show-first-row').hasClass('open')) {
                $('#toggleAllProducts').html(btnStrClose);
            } else {
                $('#toggleAllProducts').html(btnStrOpen);
            }
        });
    }


    /**
     * Copy url to clipboard
     */

    const copyBtn = document.querySelector(".copy-btn");
    if (copyBtn !== null) {
        copyBtn.onclick = copyToClipboard;
    }

    function copyToClipboard(text) {
      var inputc = document.body.appendChild(document.createElement("input"));
      const copyBtn = document.querySelector(".copy-btn");
      const lang = document.getElementsByTagName('html')[0].getAttribute('lang');
      inputc.value = window.location.href;
      // inputc.focus();
      inputc.select();
      document.execCommand('copy');
      inputc.parentNode.removeChild(inputc);
      if(lang == 'sv-SE') {
        copyBtn.innerHTML = 'Länk kopierad';
      } else {
        copyBtn.innerHTML = 'URL Copied';
      }
    }


    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    /**
    * Accordion
    */
    var accordion = document.getElementsByClassName("accordion__object");
    var i;

    for (i = 0; i < accordion.length; i++) {
        accordion[i].addEventListener("click", function() {
            var currentDataID = this.getAttribute('data-id');

            for (i = 0; i < accordion.length; i++) {
                if (currentDataID !== accordion[i].getAttribute('data-id')) {
                    var btn = accordion[i];
                    btn.classList.remove('active');

                    var dropdown = btn.nextElementSibling;
                    dropdown.classList.remove('active');
                    dropdown.style.maxHeight = null;
                }
            }

            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            panel.classList.toggle("active");

            if (!panel.classList.contains('active')) { // Stäng
                panel.style.maxHeight = null;
            } else { //Öppna
                var panelHeight = panel.scrollHeight; //calc height for panel
                var panelHeightPadding = panelHeight + 40; //calc height for panel
                panel.style.maxHeight = panelHeightPadding + "px"; // set height

                // Url
                var currentAccordionParameter = this.getAttribute('data-accordion');
                window.history.replaceState(null, null, "?panel=" + currentAccordionParameter);
            }
        });
    }

    window.addEventListener("DOMContentLoaded", () => {
        var activePanelParameter = getUrlParameter("panel");

        if (activePanelParameter) {
            var accordions = document.getElementsByClassName("accordion__object");

            for (var i = 0;  i < accordions.length; i++) {
                var accordion = accordions[i];
                var dataAccordion = accordion.getAttribute("data-accordion");

                if (dataAccordion === activePanelParameter.toLowerCase()) {
                    accordion.classList.add('active');
                    var panel = accordion.nextElementSibling;
                    panel.classList.add("active");

                    var panelHeight = panel.scrollHeight; //calc height for panel
                    var panelHeightPadding = panelHeight + 40; //calc height for panel
                    panel.style.maxHeight = panelHeightPadding + "px"; // set height

                    accordion.scrollIntoView(true);
                }
            }
        }
    });


    // calcOffsetHeight();

    // $(window).resize(function() {
    //     // winWidth = window.innerWidth;
    //     // calcOffsetHeight();
    //     // console.log(winWidth);
    // });


    const productCta = $('#productCta');
    if (productCta.length > 0) {
        $(productCta).on('click', function() {
            document.getElementById("form").scrollIntoView();
        });
    }

    /**
     * Footer
     */
    let footerUl = $('#footerNav').children('ul');
    let menuParent = footerUl.children('.menu-item-has-children');
    if (windowWidth <= 1024) {
        $(menuParent).children('a').before('<button class="footer-dropdown-btn"></button>'); // Add dropdown button to parent
        $('.footer-dropdown-btn').on('click', function() {
            if($(this).parent().hasClass('active-menu')) {
                $(this).parent().children('.sub-menu').slideUp(200);
                $(this).parent().removeClass('active-menu');
            } else {
                $(this).parent().children('.sub-menu').slideDown(200);
                $(this).parent().addClass('active-menu');
            }
        });
    }

    /**
     *
     * Glidejs hero block
     */

    const heroSlider = document.querySelector('.hero-block.glide-version');
    if(heroSlider !== null) {
        var heroGlide = new Glide('.hero-block.glide-version', {
            type: 'slider',
            perView: 1,
            gap: 0,
            autoplay: 4000,
        });
        heroGlide.mount();
    }

    $('.content-accordion__accordions--object').on('click', function() {

        $('.content-accordion__accordions--object, .content-accordion__accordions--object-expandable-content').removeClass('active'); // Close all previous (we only want one open at a time)
        $('.content-accordion__accordions--object-expandable-content').css('height', 0); // Close all previous (we only want one open at a time)

        let expandableContent = $(this).children('.content-accordion__accordions--object-expandable-content'); // Define expandle content

        let expandableContentHeight = expandableContent.children('p:first-of-type').outerHeight(); // Get open height

        if(expandableContent.hasClass('active')) {
            expandableContentHeight = 0; // Close height
        }

        expandableContent.css('height', expandableContentHeight); // Open / Close
        expandableContent.toggleClass('active');  // Class on content
        $(this).toggleClass('active'); // Class on parent
        $('.content-accordion__accordions--mobile-img.active').removeClass('active'); // Class on parent
        $(this).next('.content-accordion__accordions--mobile-img').toggleClass('active'); // Class on parent

        update_accordion_image();

    });

    update_accordion_image(); // Init

    function get_active_accordion() {
        let activeAccordion = $('.content-accordion__accordions--object.active');
        return activeAccordion;
    }

    function update_accordion_image() {
        let activeAccordion = get_active_accordion();
        let connectedImage = activeAccordion.attr('data-image');
        $('.content-accordion__image').css('background-image', 'url(' + connectedImage + ')');
    }

}

// header news glide
const headerNewsSlider = document.querySelectorAll('.header-news');
if(headerNewsSlider.length > 0) {
    headerNewsSlider.forEach(function(newsItem) {
        var headerNewsGlide = new Glide(newsItem, {
            type: 'slider',
            perView: 1,
            swipeThreshold: false, 
            dragThreshold: false
        });
        headerNewsGlide.mount();
    });
}